import { render } from "./mobile_draw_field.vue?vue&type=template&id=2f23e8d6"
import script from "./mobile_draw_field.vue?vue&type=script&lang=js"
export * from "./mobile_draw_field.vue?vue&type=script&lang=js"

import exportComponent from "/home/docuseal/docuseal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__